<template>

    <transition name="info">
        <div class="top-info" v-show="topInfo.type" :class="topInfo.type">
            <span class="content">{{ $t(topInfo.msgIndex) }}</span>
        </div>
    </transition>

</template>

<script type="text/ecmascript-6">
import {mapGetters} from 'vuex';

export default {

    computed: {

        ...mapGetters( [

            'topInfo'

        ] )

    }

};

</script>
    
<style>

    .top-info {
        /* height: 40px; */
        font-size: 20px;
        width: 100%;
        text-align: center;
        line-height: 40px;
        transform: translate3d(0, 100%, 0);
        position: absolute;
        bottom: 0;
        z-index: -1
    }

    .top-info.error {
        background-color: #f4dddd;
        color: #bf352e;
    }

    .top-info.success {
        background-color: #dff1d9;
        color: #318c31;
    }

    .info-enter-active, .info-leave-active {
      transition: all 0.3s
    }

    .info-enter, .info-leave-to {
      transform: translate3d(0, 0, 0)
    }

    @media screen and (max-width:1200px) {
        
        .top-info {
            /* height: 0.54rem; */
            line-height: 0.54rem;
            font-size: 0.26rem;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/topInfo.vue